/**
 * Contadores de oro y gemas.
 *
 * En la Fase 1 recibe valores de muestra desde `App`, porque todavía no hay
 * perfil que consultar. Cuando exista, el único cambio será de dónde salen los
 * números: la fuente será `profiles`, y el saldo solo lo modificarán funciones
 * RPC del servidor. Restar oro en el cliente sería un agujero de duplicación, y
 * por eso este componente no expone ningún setter.
 */

import { Coins, Gem } from 'lucide-react';

interface CurrencyHeaderProps {
  gold: number;
  gems: number;
  className?: string;
}

const formatter = new Intl.NumberFormat('es-ES');

export function CurrencyHeader({ gold, gems, className = '' }: CurrencyHeaderProps) {
  return (
    <div className={`flex items-center gap-2 sm:gap-3 ${className}`}>
      <span className="inline-flex items-center gap-1 rounded-full bg-slate-900/70 px-2 py-0.5 ring-1 ring-amber-400/30">
        <Coins className="h-3.5 w-3.5 text-amber-400" aria-hidden />
        <span className="text-xs font-semibold tabular-nums text-amber-100 sm:text-sm">
          {formatter.format(gold)}
        </span>
        <span className="sr-only">oro</span>
      </span>

      <span className="inline-flex items-center gap-1 rounded-full bg-slate-900/70 px-2 py-0.5 ring-1 ring-fuchsia-400/30">
        <Gem className="h-3.5 w-3.5 text-fuchsia-400" aria-hidden />
        <span className="text-xs font-semibold tabular-nums text-fuchsia-100 sm:text-sm">
          {formatter.format(gems)}
        </span>
        <span className="sr-only">gemas</span>
      </span>
    </div>
  );
}
